module.exports = __webpack_public_path__ + "img/fla.3c753b8.svg";